<input *ngIf="!isShowText" type="text" [maxlength]="maxLength" class="w-100pc border bg-white rounded text-renderer"
    [ngModel]="value" (input)="onInput($event)" (focus)="onFocus($event)" (blur)="onBlur($event)" (keydown)="onKeyDown($event)" [placeholder]="showCheckBoxWithText1 ? '' : placeHolder"
    [class]="cellClass + ' ' + customCellClass" [ngClass]="{'border-danger': isRequired && showValidator, 'disabled bg-light-grey': this.disabled}" tabindex="0">


<span *ngIf="isShowText"> {{ value }}</span>